export const signUpRoutePath = '/join';
